import React, { useState, useCallback, useEffect } from 'react';
import { usePrevious } from "../hooks";
import { Combobox, Listbox, Icon } from '@shopify/polaris';
import { ClockIcon } from '@shopify/polaris-icons';

export function TimePickerCustom(props) {

    const [value, setValue] = useState(props.value);
    const [hasError, setHasError] = useState(false);

    const prevValue = usePrevious(props.value);

    var timeArray = [], i, j;
    for (i = 0; i < 24; i++) {
        for (j = 0; j < 2; j++) {
            var time = (i === 0 ? 12 : (i > 12 ? i - 12 : i)) + ":" + (j === 0 ? "00" : 30 * j) + (i < 12 ? " AM" : " PM");
            timeArray.push({ val: time, label: time });
        }
    }

    const isValidTime = function (timeString) {
        return timeString.match(/^(0?[1-9]|1[012])(:[0-5]\d) [APap][mM]$/) != null;
    }

    const handleValueChange = useCallback(
        (newValue) => {
            document.activeElement.blur();
            setValue(newValue);
            props.handleChange(props.fieldName, newValue);
        },
        [props],
    );

    const handleValueStringChange = useCallback(
        (newValue) => {
            //var hasError = !isValidTime(newValue);
            //if (!hasError) {
            //    newValue = newValue.replace(/^0/, '').toUpperCase();
            //    setValue(newValue);
            //}
            setValue(newValue);
        },
        [],
    );

    const handleBlur = useCallback(
        () => {
            var l_hasError = !isValidTime(value);
            //setHasError(l_hasError);
            //props.handleError(props.fieldName, l_hasError);

            if (!l_hasError) {
                let newValue = value.replace(/^0/, '').toUpperCase();
                setValue(newValue);
                props.handleChange(props.fieldName, newValue);
            }
            else {
                setValue(prevValue);
                props.handleChange(props.fieldName, prevValue);
            }
        },
        [value, props],
    );

    useEffect(() => {
        if (prevValue !== props.value) {
            handleValueStringChange(props.value);
        }
    });

    const optionsMarkup = timeArray.map((option) => {
        const { label, val } = option;

        return (
            <Listbox.Option
                key={`${val}`}
                value={val}
                selected={value === val}
                accessibilityLabel={label}
            >
                {label}
            </Listbox.Option>
        );
    });

    const activator = (
        <Combobox.TextField
            prefix={<Icon source={ClockIcon} tone="subdued" />}
            label={props.label}
            placeholder="Enter time"
            value={value}
            onChange={(newValue) => handleValueStringChange(newValue)}
            error={hasError ? 'Invalid time value' : ''}
            onBlur={() => handleBlur()}
        />
    );

    return (
        <Combobox activator={activator}>
            <Listbox onSelect={(newValue) => handleValueChange(newValue)}>{optionsMarkup}</Listbox>
        </Combobox>
    );
}